// Read environment overrides defensively so a missing `process` object
// (e.g. some test/SSR contexts) never crashes module load.
function readEnv(name) {
    try {
        if (typeof process !== 'undefined' && process.env && process.env[name]) {
            return process.env[name];
        }
    } catch (e) {
        // ignore — fall through to defaults
    }
    return null;
}

const envApiBaseUrl = readEnv('REACT_APP_API_BASE_URL');
const envApiUrl = readEnv('REACT_APP_API_URL');
const envBannerPollMsRaw = readEnv('REACT_APP_BANNER_POLL_MS');
const envBannerPollMs = envBannerPollMsRaw ? parseInt(envBannerPollMsRaw, 10) : NaN;

const defaultApiUrl = 'api';
const resolvedApiUrl = envApiUrl || defaultApiUrl;

export const config = {
    apiUrl: resolvedApiUrl,
    // apiUrl: 'http://localhost:6020/api',    
    solrApiUrl: 'https://test.kluwerlawonline.com//solrapi/api',
    //solrApiUrl: 'https://beta.kluwerlawonline.com/solrapi/api/'
    //solrApiUrl: 'http://aiew1albnklo1-1935864601.eu-west-1.elb.amazonaws.com/solrapi/api/'
    // solrApiUrl: 'http://localhost:51555/api/'
    //solrApiUrl: 'http://localhost:82/api'
    // Base URL for the public .NET 10 backend (banner + future endpoints).
    // Keep this aligned with apiUrl by default to avoid local dev proxy issues.
    apiBaseUrl: envApiBaseUrl || resolvedApiUrl,
    // Re-check interval for the active banner. Default 5 minutes.
    bannerPollMs: Number.isFinite(envBannerPollMs) && envBannerPollMs > 0
        ? envBannerPollMs
        : 5 * 60 * 1000
};


// WEBPACK FOOTER //
// ./src/_helpers/config.js